import { useEffect, useState } from "react";
import { PageHeader, EmptyState } from "@/components/ui-bits";
import { Award, Download } from "lucide-react";
import api, { API_BASE } from "@/lib/api";

export default function Certificates() {
  const [results, setResults] = useState([]);
  useEffect(() => { api.get("/results").then(r => setResults(r.data.filter(x => x.status === "passed"))); }, []);

  return (
    <div>
      <PageHeader title="Certificates" subtitle="Download certificates for every assessment you've passed." />
      {results.length === 0 ? <EmptyState title="No certificates yet" hint="Pass an assessment to earn a certificate." /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {results.map(r => (
            <div key={r.id} data-testid={`cert-card-${r.id}`} className="bg-white border border-slate-200 rounded-xl p-6 relative overflow-hidden">
              <div className="absolute -top-8 -right-8 w-32 h-32 bg-blue-50 rounded-full" />
              <div className="relative">
                <Award className="w-8 h-8 text-blue-600" />
                <div className="mt-4 text-lg font-semibold text-slate-900">{r.assessment_title}</div>
                <div className="text-sm text-slate-500">Score · {r.percentage}%</div>
                <div className="text-xs text-slate-400 mt-1">Issued {r.submitted_at?.slice(0,10)}</div>
                <a
                  data-testid={`cert-download-${r.id}`}
                  href={`${API_BASE}/results/${r.id}/certificate`}
                  className="mt-5 inline-flex items-center gap-2 bg-blue-600 text-white rounded-lg px-4 py-2 text-sm font-medium hover:bg-blue-700">
                  <Download className="w-4 h-4" /> Download PDF
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
